import { BaseInput } from './base-input';

export class LongTextInput extends BaseInput {
  public constructor(data: any) {
    super(data);
  }
}
